export default "__VITE_ASSET__CTwc4tod__"